import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../reducers";
import {NotificationService} from "../../../../../services/notification.service";
import * as fromActions from "./citizens.actions"
import * as fromGraphql from "./citizens.graphql"
import {map, switchMap} from "rxjs";
import {Router} from "@angular/router";


@Injectable()
export class CitizensEffects {

  createCitizenMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createCitizenMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_CITIZEN_MUTATION,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if(result?.response?.status) {
              this.notificationService.successMessage('Created Successfully');
              if(action?.input?.citizenType === "Local"){
                this.router.navigate([`/verify-otp/login/phone/${action?.input?.profilePhone}`])
              } else if(action?.input?.citizenType === "Foreigner"){
                this.router.navigate([`/verify-otp/login/email/${action?.input?.userEmail}`])
              }
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      )
    })
  ), { dispatch: false })


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private router: Router,) {}
}
